import { getDefaultHitlv2SegmentThicknessPixels } from '@bedc/utils';

/**
 * Fallback segment values for newly drawn frames when page scale is unavailable.
 */
export const SegmentDefaults: {
	heightImperial: number;
	heightMetric: number;
	thickness: number;
} = {
	/** Standard 8ft 1 1/8in wall height in inches. */
	heightImperial: 97.125,
	/** Standard wall height in millimetres. */
	heightMetric: 2400,
	thickness: getDefaultHitlv2SegmentThicknessPixels('metric', null),
};
